'use client';

import { vars } from '@repo/config';
import { useIdleMount } from '@repo/web-chrome/lib/use-idle-mount';
import Script from 'next/script';

export function ConditionalGa4(): React.JSX.Element | null {
  const ready = useIdleMount();
  const gaId = vars.analytics.ga4MeasurementId;
  if (!ready || !gaId) {
    return null;
  }
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="cm-ga4-config" strategy="afterInteractive">
        {`window.dataLayer=window.dataLayer||[];window.gtag=window.gtag||function(){dataLayer.push(arguments)};window.gtag('js',new Date());window.gtag('config','${gaId}');`}
      </Script>
    </>
  );
}
